import styled, { css } from 'styled-components';

// Summary
export const Summary = styled.div`
	width: 100%;
	padding: 20px;
	margin-top: 16px;
	margin-bottom: 16px;
	box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
	position: relative;

	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 10px;

	img {
		width: 128px;
		height: 128px;
		flex-shrink: 0;
		border-radius: 12px;

		object-fit: cover;
	}
`;

// Contents
export const Contents = styled.div`
	width: 100%;
	padding: 24px 20px;

	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const HeadlineRow = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
`;

export const ContentText = styled.div<{ isFullBorderRadius: boolean; isContentOpen?: boolean }>`
	width: calc(100%);
	max-height: ${({ isContentOpen }) => (isContentOpen ? 'auto' : 'calc(24 * 12px + 16px)')};
	overflow: hidden;
	padding: 16px;

	-webkit-user-select: text;
	-moz-user-select: text;
	-ms-user-select: text;
	user-select: text;

	${({ isFullBorderRadius }) => {
		if (isFullBorderRadius) {
			return css`
				border-radius: 16px;
			`;
		}
		return css`
			border-top-left-radius: 16px;
			border-top-right-radius: 16px;
		`;
	}}
	background-color: ${({ theme }) => theme['warmgray-50']};
`;

export const ContentTextOpenButton = styled.div`
	width: 100%;
	height: 48px;
	border-bottom-left-radius: 16px;
	border-bottom-right-radius: 16px;
	padding: 10px 16px;

	margin-top: -16px;
	background-color: ${({ theme }) => theme['warmgray-50']};

	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
`;
